import request from '@/utils/request'
const api_name = 'tenant'
export default{
    getAllTenantList(){
        return request({
            url:`/${api_name}/getalltenant`,
            method:'get'
        })
    },
    getTenantListByCondition(pojo){
        return request({
            url:`/${api_name}/gettenantbycondition`,
            method:'post',
            headers: {
                // 关键 1：修改请求头为表单格式，替换原来的 JSON 格式
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            data:new URLSearchParams(pojo).toString()
        })
    },
    addTenant(pojo){
        return request({
            url:`/${api_name}/addtenant`,
            method:'post',
            data:pojo
        })
    },
    updateTenant(pojo){
        return request({
            url:`/${api_name}/updatetenant`,
            method:'post',
            data:pojo
        })
    },
    deleteTenant(tenantid){
        return request({
            url:`/${api_name}/deletetenant?tenantid=`+tenantid,
            method:'delete',
        })
    },
    
}







